import {FormEvent} from 'react';
import {Dispatch} from 'redux';
import {login} from '../service/auth.service';
import {fetchLoggedInUserAction} from '../store/actions/auth.actions';
import {GuestCredentials} from '../components/presentationView/parts/components/GuestModal';
import {TypedTranslation} from '../i18n';

export const handleLoginFormSubmit = (
    e: FormEvent<HTMLFormElement>,
    setLoginError: (error: TypedTranslation | undefined) => void,
    setLoginLoader: (loader: boolean) => void,
    findPresentation: (cr?: GuestCredentials) => void,
    dispatch: Dispatch
): void => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const username = formData.get('username');
    const password = formData.get('password');

    if (!username || !password || typeof username !== 'string' || typeof password !== 'string') {
        return;
    }

    setLoginError(undefined);
    setLoginLoader(true);

    login({username, password})
        .then(() => findPresentation())
        .catch((error) => {
            if (error.response?.status === 401) {
                setLoginError('form.invalidCredentials');
            }
        })
        .finally(() => {
            setLoginLoader(false);
            dispatch(fetchLoggedInUserAction());
        });
};
